import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FitscoveryError, Guid } from '@fitscovery/common/types';
import { environment } from 'apps/partner-web/src/environments/environment';
import { Observable } from 'rxjs';
import { catchError, retry, share, map } from 'rxjs/operators';
import { Post, GetPostsByPartnerIdResponse, GetUserPostsPointsByPartnerIdResponse } from '../models';
import { PostService } from './abstract-post.service';
import { Partner, PartnerState } from '@fitscovery/partner/data-access';
import { Select } from '@ngxs/store';

@Injectable()
export class ApiPostService extends PostService {

  filteredData: Event[];

  constructor(private httpClient: HttpClient) {
    super();
  }

  create(post: Post): Observable<Post> {
    post.createdAt = new Date();
    return this.httpClient.post<Post>(`${environment.azureFunctionsApi.posts}/posts`, post)
      .pipe(
        catchError((error) => {
          throw new FitscoveryError({ message: error.message, data: error });
        })
      );
  }

  delete(id: string | Guid): Observable<Post | any> {
    return this.httpClient.delete<Post>(`${environment.azureFunctionsApi.posts}/posts/${id}/`);
  }

  getPostsByUserId(id: string | Guid): Observable<Post[]> {
    return this.httpClient.get<Post[]>(`${environment.azureFunctionsApi.posts}/posts/userId/${id}`)
      .pipe(
        share(),
        retry(3),
        catchError((error) => {
          throw new FitscoveryError({
            message: 'Failed to get posts after retrying 3 times. Kindly refresh or try again later.',
            data: error
          });
        })
      );
  }

  getMemberPostsByPartnerId(id: string | Guid, pageNumber: number = 1, pageSize: number = 5): Observable<Post[]> {
    return (this.httpClient.post(`${environment.azureFunctionsApi.posts}/posts/members/partnerId/${id}`, { pageNumber: pageNumber, pageSize: pageSize }) as any)
      .pipe(
        map((response: GetPostsByPartnerIdResponse) => {
          return response.data;
        }),
        share(),
        retry(3),
        catchError((error) => {
          throw new FitscoveryError({
            message: 'Failed to get posts after retrying 3 times. Kindly refresh or try again later.',
            data: error
          });
        })
      );
  }

  getUserPostsPointsByPartnerId(id: string | Guid, startDate: Date | string, endDate: Date | string): Observable<GetUserPostsPointsByPartnerIdResponse> {
    const data = {
      partnerId: id,
      startDate: startDate,
      endDate: endDate
    };

    return (this.httpClient.post(`${environment.azureFunctionsApi.posts}/posts/userPoints/partnerId/${id}`, data) as any)
      .pipe(
        map((response: GetUserPostsPointsByPartnerIdResponse) => {
          return response;
        }),
        share(),
        retry(3),
        catchError((error) => {
          throw new FitscoveryError({
            message: 'Failed to get posts after retrying 3 times. Kindly refresh or try again later.',
            data: error
          });
        })
      );
  }

  update(post: Post): Observable<any> {
    post.createdAt = new Date();
    return this.httpClient.put(`${environment.azureFunctionsApi.posts}/posts/${post.id}`, post);
  }
}
